export default __webpack_public_path__ + "static/media/image.3ddab903.svg";